// extracted by mini-css-extract-plugin
export default {"root":"gallery_root__bxWT7"};